import React from 'react';
import { CheckIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { ZoomableImage } from '../ZoomableImage';
import { PROJECT_INCLUDES, TECH_PROOF } from '../../data/catio';

/**
 * Ready-to-build system + real technical proof, in one section.
 * What every project includes → the real pages that prove it.
 */
export function SystemSection() {
  return <section id="system" aria-labelledby="system-title" className="bg-paper py-12 sm:py-20" data-id="element-292" data-mp="3og8odamq8k6m">
      <div className="mx-auto w-full max-w-6xl px-5 sm:px-8" data-id="element-293" data-mp="3t6fbt75i5yna">
        <SectionHeading id="system-title" eyebrow="Every project follows the same ready-to-build system" title="Materials, Measurements and Assembly — Organized for Each Build" lead="Each project brings the key planning information together, so you can review the design before buying materials or making cuts." data-id="element-294" data-mp="3t806qxvqbjlo" />

        <ul className="mt-7 grid grid-cols-2 gap-x-4 gap-y-3 border-y border-line py-5 sm:mt-9 sm:grid-cols-4 sm:gap-x-6" data-id="element-295" data-mp="3af60qtg331tl">
          {PROJECT_INCLUDES.map(item => <li key={item} className="flex items-center gap-2.5 text-[0.92rem] font-semibold text-ink" data-id="element-296" data-mp="6r7ujy2517fu">
              <CheckIcon className="h-4 w-4 shrink-0 text-wood" strokeWidth={2.5} aria-hidden data-id="element-297" data-mp="kqgy9y95q92x" />
              {item}
            </li>)}
        </ul>

        <ul className="mt-9 grid gap-9 sm:mt-12 md:grid-cols-2 md:gap-x-6 md:gap-y-10" data-id="element-298" data-mp="fsfe19zzw3pv">
          {TECH_PROOF.map(item => {
          const portrait = item.height > item.width;
          return <li key={item.label} className="flex flex-col" data-id="element-299" data-mp="3k3rfg2ywvq2h">
                <h3 className="font-display text-[1.4rem] leading-tight text-ink sm:text-[1.6rem]" data-id="element-300" data-mp="1swidgodekug">
                  {item.label}
                </h3>
                <p className="label-tech mt-1.5 text-graphite/70" data-id="element-301" data-mp="35gy93n7ddumf">{item.source}</p>
                <div className="mt-3 flex flex-1 items-center justify-center overflow-hidden rounded-[12px] border border-line bg-white p-2 shadow-[0_22px_40px_-26px_rgba(28,31,28,0.45)] sm:p-3 md:aspect-[1/1]" data-id="element-302" data-mp="35ev7e5wuud1v">
                  <ZoomableImage image={item} className="flex h-full items-center justify-center" imgClassName={`mx-auto object-contain ${portrait ? 'max-h-[560px] w-auto md:h-full md:max-h-none' : 'w-full md:max-h-full'}`} data-id="element-303" data-mp="14cvz3tvc8iad" />
                </div>
              </li>;
        })}
        </ul>
        <p className="label-tech mt-6 text-center text-graphite/60" data-id="element-304" data-mp="qefjfdfhzhg3">
          <span className="md:hidden" data-id="element-305" data-mp="qgsbijeyz86v">Tap any image to enlarge</span>
          <span className="hidden md:inline" data-id="element-306" data-mp="vch3o1ontmt5">Click any image to enlarge</span>
        </p>
      </div>
    </section>;
}